export default __webpack_public_path__ + "fe1c53411c1360e587a680ff42d38f9a.png";